import type { ReactElement } from "react";

import { Body } from "@/components/Text";
import type { BodyProps, InputTextAlign } from "@/types";
import { mergeSx } from "@/utils";

type InputListLabelProps<RC extends ReactElement | undefined = undefined> =
  BodyProps<RC> & { textAlign?: InputTextAlign };

export function InputListLabel<
  RC extends ReactElement | undefined = undefined,
>({
  size = "small",
  className,
  sx,
  textAlign,
  testId = "InputListLabel",
  ...props
}: InputListLabelProps<RC>) {
  return (
    <Body
      {...props}
      size={size}
      className={`${className ?? ""} InputListLabel`}
      testId={testId}
      sx={mergeSx(
        {
          mb: "base.spacing.x2",
          py: "base.spacing.x1",
          textAlign: textAlign ?? "left",
        },
        sx,
      )}
    />
  );
}

InputListLabel.displayName = "InputList.Label";
